import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingYears': false,
  'years': [],
  'loading': false,
  'salesByDealersList': [],
  'salesByModelsList': [],
  'salesByColorsList': [],
  'stockByDealersList': [],
  'stockByModelsList': [],
  'stockByReservationsList': [],
  'stockByColorsList': [],
  'salesDetail': [],
  'salesDetailByPage': [],
  'pageSize': 20,
  'pageNumber': 0,
  'downloading': false,
  'urlSalesDetailFile': '',
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const vehiclesKpi = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_HISTORICAL_VEHICLES_SALES]: (state, action) => ({
      ...state,
      'loadingYears': false,
      'salesByDealersList': [],
      'salesByModelsList': [],
      'salesByColorsList': [],
    }),
    [ActionTypes.FETCHING_YEARS_WITH_HISTORICAL_VEHICLES_SALES]: (state, action) => ({
      ...state,
      'loadingYears': true,
    }),
    [ActionTypes.FETCHED_YEARS_WITH_HISTORICAL_VEHICLES_SALES]: (state, action) => ({
      ...state,
      'loadingYears': false,
      'years': action.response.data,
    }),
    [ActionTypes.FETCHED_YEARS_WITH_HISTORICAL_VEHICLES_SALES_FAILED]: (state, action) => ({
      ...state,
      'loadingYears': false,
      'years': [],
    }),
    [ActionTypes.FETCHING_HISTORICAL_VEHICLES_SALES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_HISTORICAL_VEHICLES_SALES]: (state, action) => {
      const infoType = action.payload;

      if (infoType === 'dealers') {
        return ({
          ...state,
          'loading': false,
          'salesByDealersList': action.response.data,
        });
      }

      if (infoType === 'models') {
        return ({
          ...state,
          'loading': false,
          'salesByModelsList': action.response.data,
        });
      }

      return ({
        ...state,
        'loading': false,
        'salesByColorsList': action.response.data,
      });
    },
    [ActionTypes.FETCHED_HISTORICAL_VEHICLES_SALES_FAILED]: (state, action) => {
      const infoType = action.payload;

      if (infoType === 'dealers') {
        return ({
          ...state,
          'loading': false,
          'salesByDealersList': [],
        });
      }

      if (infoType === 'models') {
        return ({
          ...state,
          'loading': false,
          'salesByModelsList': [],
        });
      }

      return ({
        ...state,
        'loading': false,
        'salesByColorsList': [],
      });
    },
    [ActionTypes.CLEAR_VEHICLES_STOCK]: (state, action) => ({
      ...state,
      'loading': false,
      'stockByDealersList': [],
      'stockByModelsList': [],
      'stockByReservationsList': [],
      'stockByColorsList': [],
    }),
    [ActionTypes.FETCHING_VEHICLES_STOCK]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLES_STOCK]: (state, action) => {
      const infoType = action.payload;

      if (infoType === 'dealers') {
        return ({
          ...state,
          'loading': false,
          'stockByDealersList': action.response.data,
        });
      }

      if (infoType === 'models') {
        return ({
          ...state,
          'loading': false,
          'stockByModelsList': action.response.data,
        });
      }

      if (infoType === 'reservations') {
        return ({
          ...state,
          'loading': false,
          'stockByReservationsList': action.response.data,
        });
      }

      return ({
        ...state,
        'loading': false,
        'stockByColorsList': action.response.data,
      });
    },
    [ActionTypes.FETCHED_VEHICLES_STOCK_FAILED]: (state, action) => {
      const infoType = action.payload;

      if (infoType === 'dealers') {
        return ({
          ...state,
          'loading': false,
          'stockByDealersList': [],
        });
      }

      if (infoType === 'models') {
        return ({
          ...state,
          'loading': false,
          'stockByModelsList': [],
        });
      }

      if (infoType === 'reservations') {
        return ({
          ...state,
          'loading': false,
          'stockByReservationsList': [],
        });
      }

      return ({
        ...state,
        'loading': false,
        'stockByColorsList': [],
      });
    },
    [ActionTypes.CLEAR_HISTORICAL_VEHICLES_SALES_DETAIL]: (state, action) => ({
      ...state,
      'loading': false,
      'salesDetail': [],
      'salesDetailByPage': [],
      'pageNumber': 0,
      'pageSize': 20,
      'downloading': false,
      'urlSalesDetailFile': '',
    }),
    [ActionTypes.FETCHING_HISTORICAL_VEHICLES_SALES_DETAIL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_HISTORICAL_VEHICLES_SALES_DETAIL]: (state, action) => ({
      ...state,
      'loading': false,
      'salesDetail': action.response.data,
      'salesDetailByPage': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.FETCHED_HISTORICAL_VEHICLES_SALES_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'salesDetail': [],
      'salesDetailByPage': [],
    }),
    [ActionTypes.CHANGE_SALES_DETAIL_LIST_PAGE]: (state, action) => ({
      ...state,
      'urlSalesDetailFile': '',
      'pageNumber': action.payload,
      'salesDetailByPage': [...getPage(state.salesDetail, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_SALES_DETAIL_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'urlSalesDetailFile': '',
      'pageSize': action.payload,
      'pageNumber': 0,
      'salesDetailByPage': [...getPage(state.salesDetail, 0, action.payload)],
    }),
    [ActionTypes.DOWNLOADING_HISTORICAL_VEHICLES_SALES_DETAIL]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_HISTORICAL_VEHICLES_SALES_DETAIL]: (state, action) => ({
      ...state,
      'downloading': false,
      'urlSalesDetailFile': action.response.data,
    }),
    [ActionTypes.DOWNLOADED_HISTORICAL_VEHICLES_SALES_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
      'urlSalesDetailFile': '',
    }),
    [ActionTypes.CLEAR_URL_FILE_FOR_SALES_DETAIL]: (state, action) => ({
      ...state,
      'downloading': false,
      'urlSalesDetailFile': '',
    }),
  })(state, action);
};
